import type { FunctionComponent } from "react";

import CardValue from "~/components/Card/components/CardValue.tsx";
import Headline from "~/components/Headline";
import type { EInvoicePreviewResponse } from "~/modules/billing/api/eInvoice/eInvoiceTypes.ts";

import { formatEInvoiceDate } from "../eInvoiceFormat.ts";

type Props = { payment: EInvoicePreviewResponse["payment"] };

const EInvoicePaymentSection: FunctionComponent<Props> = ({ payment }) => (
	<div className="flex flex-col gap-3">
		<Headline type="h5">Zahlung</Headline>
		<CardValue label="Zahlungsbedingungen">{payment.terms ?? "—"}</CardValue>
		<CardValue label="Fälligkeitsdatum">{formatEInvoiceDate(payment.dueDate)}</CardValue>
	</div>
);

export default EInvoicePaymentSection;
